import React, { Component } from "react";
import { connect }          from "react-redux";
import { Player }           from "video-react";
//UI COMPONENT
import {List, ListItem }  from "material-ui/List"
import TextField          from "material-ui/TextField";
import {Menu}             from "material-ui/Menu";
import {MenuItem }        from "material-ui/MenuItem";
import RaisedButton       from "material-ui/RaisedButton";
import { Grid, Row, Col } from "react-material-responsive-grid";
import Dialog             from 'material-ui/Dialog';
import SelectField        from "material-ui/SelectField";
import DatePicker         from "material-ui/DatePicker";
import AppBar             from "material-ui/AppBar";
import IconButton         from "material-ui/IconButton";
import RefreshIndicator   from 'material-ui/RefreshIndicator';

//IMPORT COMPONENT
import Loader              from "../Components/component_Loader";
import ErrorMessage        from "../Components/component_MsgError";
import Divider             from "../Components/component_Divider";
import ImageSlider         from "../Components/component_ImageSlider";
import MenuTile            from "../Components/component_SGMenuTiles.js";
import SchermataSpecifiche from "../Components/component_SchermataSpecifiche";
import PageNotFound        from "../Components/component_PageNotFound";
import ExplanationPage     from "../Components/component_ExplanationPage";
import ExplanationPortal   from "../Components/component_ExplanationPortal";

import { Slide }                           from 'react-slideshow-image';
import { login, logout, login_removeError} from '../Actions/Action_Authentication.js';
import { getUserInfo }                     from "../Actions/Action_ServiceRequest_Home";
import { recoverCredentials }              from '../Actions/Action_ServiceRequest_RecuperaCredenziali';
import {openLoginDialog, closeLoginDialog} from "../Actions/Action_ServiceRequest_Index";

import IconLogin        from "material-ui/svg-icons/action/input"
import IconArrowBack    from "material-ui/svg-icons/navigation/arrow-back"
import IconAccount      from "material-ui/svg-icons/action/account-circle";
import IconArrowForward from "material-ui/svg-icons/navigation/arrow-forward";
import IconHome         from "material-ui/svg-icons/action/home";
import { checkEmail, checkCap, checkNull, checkPivaForm, checkEmailForm, checkCapForm , checkPassword, checkUserLanguage} from "../Utils/Check_Value";
import { LABEL_Login, LABEL_Cancel, LABEL_DIALOG_CONTENT_RecoverPassword, LABEL_SignIn, LABEL_PasswordRecovery, LABEL_Email, LABEL_Required,
         LABEL_DonTHaveAccount, LABEL_Enter_Username, LABEL_ForgotPassword, LABEL_Username, LABEL_Enter_Email, LABEL_Send, LABEL_PAGE_HOME_Videos, LABEL_PAGE_HOME_WhatIs,
         LABEL_SignInNow, LABEL_Enter_Password, LABEL_Password, LABEL_PAGE_HOME_Portal, LABEL_PAGE_HOME_Bilapp, LABEL_PAGE_HOME_Versions, LABEL_PAGE_HOME_Images   } from "../Utils/Strings/Labels"
import "../CSS/style_Index2.css"

import Schermata_1 from "../Images/SchermateBilapp/schermata_Bilapp_1.jpg"
import Schermata_2 from "../Images/SchermateBilapp/schermata_Bilapp_2.jpg"
import Schermata_3 from "../Images/SchermateBilapp/schermata_Bilapp_3.jpg"
import Schermata_4 from "../Images/SchermateBilapp/schermata_Bilapp_4.jpg"
import JeansPNG    from "../Images/jeans.png"


import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";
import {LINK_INDUSTRIAL_SOFTWARE, LINK_BILANCIAI, LINK_VIDEO_BILAPP} from "../Utils/Strings/URL";
import * as ROLES  from "../Utils/Roles_Types.js";
import "video-react/dist/video-react.css"; // import css

const styles = {
  filterDialog : {
    width    : '100%',
    maxWidth : 'none'
  },
  refresh: {
    display: 'inline-block',
    position: 'relative',
    background: "red"
  }
};

const images = [
    Schermata_1,
    Schermata_2,
    Schermata_3,
    Schermata_4,
];

const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERLANGUAGE  = checkUserLanguage(USERINFO);
console.log(USERLANGUAGE);
class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
        dialogLogin : {
            opened: false,
        },
        username : "", 
        password : "",
        dialogChooseAction: {
            opened : false
        },
        recoverDialog: {
            visible       : false,
            Email         : "",
            msgErrorEmail : ""
        },
        pageRendered : LABEL_PAGE_HOME_Bilapp[USERLANGUAGE]
    }
    
    this.props.dispatch(openLoginDialog())
  }

  onTextChange = (event, position) => {
    this.props.dispatch(login_removeError());  
    this.setState( { [position]: event.target.value } );
  }

  onClickButtonLogin = event => {
    if (typeof event !== "undefined")
      event.preventDefault();
    const creds = {
      username: this.state.username.trim(),
      password: this.state.password.trim()
    };

    this.props.dispatch(login(creds));
  }

  handleRecoverDialogShow = (visible = false) =>{
    var recoverDialog     = this.state.recoverDialog;
    recoverDialog.visible = visible;
    if(visible == true)
      recoverDialog.msgErrorEmail = "";
    this.setState({recoverDialog:recoverDialog});
  };

  handleRecoverTextChange = (event, text) =>{
    var recoverDialog     = this.state.recoverDialog;
    recoverDialog[text]   = event.target.value;
    if(recoverDialog[text] == "")
      recoverDialog["msgError"+text] = LABEL_Required[USERLANGUAGE];
    this.setState({recoverDialog:recoverDialog});
  }

  handleSendEmailRecoverDialog = () => {
    var recoverDialog     = this.state.recoverDialog;
    if(recoverDialog.Email == ""){
      recoverDialog.msgErrorEmail = LABEL_Required[USERLANGUAGE];
    }else{
      this.props.dispatch(recoverCredentials(recoverDialog.Email));
      recoverDialog.visible = false;
    }
    this.setState({recoverDialog:recoverDialog});
  }
  
  componentDidMount() {
    this.props.dispatch(getUserInfo());
  }

  renderPage = page => this.setState({pageRendered: page})

  
  render() {

    let loginStyle = {
        width: window.innerWidth > 1000 ? "50%" :  window.innerWidth > 800 ? "60%" : window.innerWidth > 500 ? "70%" : "90%"
    }

    const loginAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={() => this.props.dispatch(closeLoginDialog())}
      />,
      <RaisedButton
        label={LABEL_Login[USERLANGUAGE]}
        primary={true}
        onClick={() => this.onClickButtonLogin()}
      />
    ];

    const chooseAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={() => this.setState({dialogChooseAction: {opened : false}})}
      />
    ];

    const recoverDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={() => this.handleRecoverDialogShow(false)}
      />,
      <RaisedButton
        label={LABEL_Send[USERLANGUAGE]}
        primary={true}
        onClick={this.handleSendEmailRecoverDialog}
      />
    ];
    var iconButton;
    if( this.props.userInfoFetching === true){ iconButton = <IconButton><RefreshIndicator size={40} left={10} top={0} status="loading" style={styles.refresh} /></IconButton>;
    }else if( this.props.userInfo === null )
        iconButton = <IconButton onClick={()=>  this.props.dispatch(openLoginDialog()) }><IconAccount/></IconButton>;
    else
        iconButton = <IconButton onClick={()=>  this.setState({dialogChooseAction: {opened : true}}) } ><IconLogin/></IconButton>;

    var pageRendered = this.state.pageRendered;
  return <div>
        <Loader isFetching={this.props.isFetching}/>
        <ErrorMessage message={this.props.errorMessage} />
        
        {/*<AppBar
            title                  = { <center>{pageRendered}</center> }
            iconElementLeft        = { this.state.pageRendered === LABEL_PAGE_HOME_Bilapp[USERLANGUAGE] && <div></div> || <IconButton onClick = {() => this.setState({pageRendered : LABEL_PAGE_HOME_Bilapp[USERLANGUAGE]})}><IconArrowBack/></IconButton> }
            onLeftIconButtonClick  = { null }
            iconElementRight       = { iconButton }
            onRightIconButtonClick = { this.props.rightNavButtonFunction}
          />
        <PageNotFound message = "Work In Progress : Il nuovo sito sarà presto online. Nel frattempo è possibile accedere all'area riservata premendo il pulsante in alto a destra." />*/}
        {<div className = "sg-index-container flex-container"> </div>}

        <Dialog
            title={LABEL_Login[USERLANGUAGE]}
            autoScrollBodyContent={false}
            modal={true}
            contentStyle={loginStyle}
            open={this.props.dialogLoginOpened}
            contentStyle={{backgroundColor: "rgba(255,255,255,0.8)!important"}}>

            <form onSubmit={event => this.onClickButtonLogin(event)}>
                <div className="input">
                    <TextField 
                        className         = "input-label"
                        onChange          = {event => this.onTextChange(event, 'username')}
                        hintText          = {LABEL_Enter_Username[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Username[USERLANGUAGE]}
                        fullWidth         = {true}
                        errorText         = {this.props.usernameError} />
                </div>

                <div className="input">
                    <TextField 
                        className         = "input-label"
                        type              = "password"
                        onChange          = {event => this.onTextChange(event, 'password')}
                        hintText          = {LABEL_Enter_Password[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Password[USERLANGUAGE]}
                        fullWidth         = {true}
                        errorText         = {this.props.passwordError}/>

                    <div style={{width: "100%", textAlign: "right", marginTop: "10px"}}>
                        <span onClick={() => this.handleRecoverDialogShow(true)} style={{cursor: "pointer", fontSize: "15px", color:"rgb(107, 154, 221)", margin: "10px"}}>
                            <a>{LABEL_ForgotPassword[USERLANGUAGE]}</a>
                        </span>
                    </div>
                </div>

                <div className="error-message">{this.props.loginError}</div>

                <div className="login-btn">
                    <RaisedButton
                        label={LABEL_Login[USERLANGUAGE]}
                        primary={true}
                        fullWidth={true}
                        type="submit"
                    />
                </div>
            </form>

            <div className="login-btn" style={{textAlign: "center", marginBottom: "0px"}}>
                {LABEL_DonTHaveAccount[USERLANGUAGE]} <a href={ROUTE.SignIn} style={{cursor: "pointer", fontSize: "15px", color:"rgb(107, 154, 221)"}}> {LABEL_SignInNow[USERLANGUAGE]} </a>
            </div>
            
        </Dialog>

        <Dialog
            title={LABEL_PasswordRecovery[USERLANGUAGE]}
            actions={recoverDialogAction}
            modal={true}
            contentStyle={styles.filterDialog}
            open={this.state.recoverDialog.visible}
            >
            <p>{LABEL_DIALOG_CONTENT_RecoverPassword[USERLANGUAGE]}</p>
                <div className="login-btn">
                    <TextField className="input-label"
                        onChange={event => this.handleRecoverTextChange(event, 'Email')}
                        hintText={LABEL_Enter_Email[USERLANGUAGE]}
                        floatingLabelText={LABEL_Email[USERLANGUAGE]}
                        errorText={this.state.recoverDialog.msgErrorEmail}
                        fullWidth={true} /> 
                </div>
            </Dialog>
      </div>;
  }
}


function mapStateToProps(state) {
  const { indexReducer } = state;
  const { isFetching, loginMessage, loginError, isAuthenticated, errorMessage, 
    userInfo, dialogLoginOpened, usernameError, passwordError, userInfoFetching } = indexReducer;
  return {
    userInfo          ,
    isFetching        ,
    loginError        ,
    loginMessage      ,
    errorMessage      ,
    usernameError     ,
    passwordError     ,
    isAuthenticated   ,
    dialogLoginOpened ,
    userInfoFetching  
  };
}

export default connect(mapStateToProps)(Index);


// WEBPACK FOOTER //
// ./src/Containers/Index.js